<template>
  <div id="resume">
    <b-container style="margin-top: 100px; margin-bottom: 100px;">
      <b-row>
        <!-- <b-col lg="3" md="4" style="text-align: center;">
          Professional Experience
        </b-col> -->
        <b-col lg="12" md="12">
            
            <div style="margin-bottom: 50px;" v-scroll-reveal="{ delay: 100 }">
              <h2 class="section-title">Resume</h2>
              <!-- <p class="text-gray">Firms I've worked with, etc. etc.</p> -->
            </div>
            <div>

              <div v-scroll-reveal="{ delay: 100 }">
                <b-row>
                  <b-col lg="3" md="4" style="text-align: center;">
                    <img src="/resumepreview.jpg" width="200" class="resume-preview"/>
                    <div style="text-align: center; margin-top: 30px;">
                      <a href="https://katpacitti.com/KPacitti_Resume_2026.pdf" class="eden-button" target="_blank">View Resume</a>
                    </div>
                    <!-- <div class="uni" style="margin-bottom: 40px; margin-top: 20px;">March 2023 - Present</div> -->
                  </b-col>
                  <b-col lg="9" md="8">
                    <!-- <p class="section-subtitle" style=" font-size: 18px;">Eden Couture, LLC</p> -->
                    <p>
                      <!-- View my resume here: -->
                    </p>
                    <!-- <div>Working on Eden has involved the following skills:</div>
                    <ul style="padding-left: 40px;">
                      <li>Managing a team of clothing designers, collecting feedback and ensuring their voice is heard</li>
                      <li>Managing and accomplishing short term and long term goals with the Eden team</li>
                      <li>Maintaining professional contact with clients and designers</li>
                      <li>Utilizing social media to grow brand exposure</li>
                    </ul> -->
                  </b-col>
                </b-row>
              </div>
            </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import {BRow, BCol, BContainer, BCard, } from 'bootstrap-vue'
export default {
  components: {
    BContainer,
    BRow,
    BCol,
    BCard,
  },
  data() {
    return {
      skillItems: [
        {
          img: '/wordlogo.png',
          text: 'MS Word'
        },
        {
          img: '/excellogo.png',
          text: 'MS Excel'
        },
        {
          img: '/abacuslogo.png',
          text: 'Abacus Law'
        },
        {
          img: '/lexisnexis.png',
          text: 'Lexis Nexis'
        },
      ]
    }
  }
}
</script>

<style lang="css">

.resume-preview {
  border-radius: 10px;
  box-shadow: 0px 5px 15px #00000022;
}
.eden-button {
  background: #ffa318;
  color: white !important;
  padding: 8px 15px;
  border-radius: 10px;
  text-decoration: none !important;
  transition: all .2s ease;
}

.eden-button:hover {
background: #ffa318cc;
}




</style>
